import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CHUNK_SIZE = 4 * 1024 * 1024;

const guessType = (file) => {
  if (file.type) return file.type;
  const ext = file.name.split(".").pop().toLowerCase();
  return { wav: "audio/wav", mp3: "audio/mpeg", aif: "audio/aiff", aiff: "audio/aiff", flac: "audio/flac", jpg: "image/jpeg", jpeg: "image/jpeg", png: "image/png", webp: "image/webp" }[ext] || "";
};

export const uploadFileChunked = async (file, token, onProgress) => {
  const headers = { Authorization: `Bearer ${token}` };
  const content_type = guessType(file);
  const init = await axios.post(
    `${API}/admin/uploads/init`,
    { filename: file.name, content_type, total_size: file.size },
    { headers }
  );
  const uploadId = init.data.upload_id;
  let offset = 0;
  while (offset < file.size) {
    const chunk = file.slice(offset, offset + CHUNK_SIZE);
    await axios.put(`${API}/admin/uploads/${uploadId}/chunk`, chunk, {
      headers: { ...headers, "Content-Type": "application/octet-stream" },
    });
    offset += chunk.size;
    onProgress?.(Math.min(99, Math.round((offset / file.size) * 100)));
  }
  const done = await axios.post(`${API}/admin/uploads/${uploadId}/complete`, null, { headers });
  onProgress?.(100);
  return done.data;
};
